module.exports = __webpack_public_path__ + "img/photo2_9.cceddee9.jpg";